export default "__VITE_ASSET__20a2fc7c__"